import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useQuery } from 'convex/react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Icons } from '@/components/ui/icons';
import { Card, CardContent } from '@/components/ui/card';
import { CouponsTable } from '@/components/features/coupons/coupons-table';
import { CouponModal } from '@/components/features/coupons/coupon-modal';
import { useTranslation } from 'react-i18next';

const CouponsPage = () => {
  const { t } = useTranslation('operator');
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const coupons = useQuery(api.app.coupons.queries.listCoupons);
  const isLoading = coupons === undefined;

  return (
    <div className='p-6 space-y-6' data-testid='coupons-page'>
      {/* Header */}
      <div className='flex items-center justify-between'>
        <div className='flex items-center gap-3'>
          <div>
            <h1 className='text-2xl font-semibold'>{t('coupons.title')}</h1>
            <p className='text-sm text-muted-foreground mt-1'>{t('coupons.subtitle')}</p>
          </div>
          {!isLoading && (
            <Badge variant='secondary' className='ml-2 tabular-nums'>
              {coupons.length}
            </Badge>
          )}
        </div>
        <Button onClick={() => setCreateModalOpen(true)} data-testid='coupons-create'>
          <Icons.Plus className='h-4 w-4 mr-2' />
          {t('coupons.create')}
        </Button>
      </div>

      {/* Table */}
      <Card>
        <CardContent className='p-4'>
          <CouponsTable coupons={coupons ?? []} isLoading={isLoading} />
        </CardContent>
      </Card>

      {/* Create Modal */}
      <CouponModal open={createModalOpen} onOpenChange={setCreateModalOpen} coupon={null} />
    </div>
  );
};

export const Route = createFileRoute('/_protected/operators/coupons')({
  component: CouponsPage,
});
